import {
  SET_LISTEN_RECORD_MODAL_VISIBLE,
  SET_CURRENT_RECORD_URL,
  CLEAR_CURRENT_RECORD_URL,
  SET_CURRENT_CALL_INFO,
  CLEAR_CURRENT_CALL_INFO,
} from './callHistoryActionTypes';

export const setListenModalVisible = (visible) => ({
  type: SET_LISTEN_RECORD_MODAL_VISIBLE,
  payload: visible,
});

export const setCurrentRecordUrl = (recordUrl) => ({
  type: SET_CURRENT_RECORD_URL,
  payload: recordUrl,
});

export const clearCurrentRecordUrl = () => ({
  type: CLEAR_CURRENT_RECORD_URL,
});

export const setCurrentCallInfo = (callInfo) => ({
  type: SET_CURRENT_CALL_INFO,
  payload: callInfo,
});

export const clearCurrentCallInfo = () => ({
  type: CLEAR_CURRENT_CALL_INFO,
});
